import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, addCodeRedNoVehicleToQuote } from '../../../../actions/salesActions';

class TravelByVehicle extends React.PureComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {};

        this.handleEventNoCar = this.handleEventNoCar.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
    }

    async handleEventNoCar() {
        await this.props.dispatchAction(addCodeRedNoVehicleToQuote());
    }

    async handleNextStep() {
        await this.props.dispatchAction(handleNextStep());
    }

    public render() {
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <p className="text-center">
                            Excellent! Let’s start with the car that you (the policyholder) drive. This will help our emergency responders to identify you, in case of an emergency.
                        </p>

                        <p className="text-center">
                            <strong>Please tell us whether you travel by car</strong>
                        </p>

                        <div className="row d-flex justify-content-center mt-lg-4">
                            <div className="col-md-6 col-xl-4">
                                <button type="button" id="btnCodeRedNoVehicle" className="btn btn-outline-red mt-3 mt-lg-0 w-100" onClick={this.handleEventNoCar}>No, I don't</button>
                            </div>

                            <div className="col-md-6 col-xl-4">
                                <button type="button" id="btnCodeRedYesVehicle" className="btn btn-outline-red mt-3 mt-lg-0 w-100" onClick={this.handleNextStep}>Yes, I do</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return { }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TravelByVehicle);